import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const Sos = props => (
    <SvgIcon {...props}>
        <path
            d="M6.585 3.472l.058.104 1.393 2.928a.922.922 0 01-.206 1.07l-.094.08-1.528 1.14a12.467 12.467 0 004.233 4.077l.35.2 1.223-1.424c.268-.313.711-.437 1.113-.322l.12.041L16 12.508V16l-4.721.001C6.372 14.07 2.777 9.847 2.009 4.75c-.066-.452.211-.88.657-1.042l.115-.035 2.651-.642c.452-.109.92.076 1.153.441zM14.5 2c.53 0 1.041.12 1.501.338v6.323a3.5 3.5 0 01-3.076-.037l-.039-.02-1.551.388a.27.27 0 01-.33-.309l.391-1.568A3.498 3.498 0 0114.5 2zm-.348 4.04a.456.456 0 00-.322.13.437.437 0 00-.095.486.433.433 0 00.417.267.464.464 0 00.321-.127.423.423 0 00.131-.314.43.43 0 00-.275-.406.45.45 0 00-.177-.035zm.38-2.91h-.744v1.475c0 .158.01.315.028.47.015.125.034.251.057.38l.018.096h.539c.03-.162.055-.32.074-.476.016-.13.025-.26.027-.391l.001-1.554z"
            fill="#currentColor"
            fillRule="evenodd"
            stroke="none"
        />
    </SvgIcon>
);

export default Sos;
